import HostInquirer from './HostInquirer'

class CustomForms extends HostInquirer {
    constructor(context) {
        super(context)
        this.initiated = false
        this.formElementsToRegister = []
    }

    // first we see what forms have the class on the page
    init = () => {
        if (!this.initiated) {
            this.initiated = true

            this.formElementsToRegister = this.getAllElementsFromQuery('form.PicoSignupForm')

            if (this.formElementsToRegister.length) {
                this.registerClassCallbacks()
            }
        }
    }

    registerClassCallbacks = () => {
        const submitHandler = (e) => {
            e.preventDefault()
            const email = e.target.querySelector('input[type="email"]')
            if (!email) {
                // eslint-disable-next-line no-console
                console.error('Pico: Failed to find input of type="email" within the form') // would be cool to link to help article here!
            } else {
                this.context.Pico.handleFormSubmit(email.value)
            }

            return false
        }

        this.formElementsToRegister.forEach((form) => {
            if (form.attachEvent) {
                form.attachEvent('submit', submitHandler)
            } else {
                form.addEventListener('submit', submitHandler)
            }
        })
    }
}

export default CustomForms
